import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import AboutUsSection from './components/AboutUsSection';
import ProblemSection from './components/ProblemSection';
import ServicesSection from './components/ServicesSection';
import BenefitsSection from './components/BenefitsSection';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import EmergencySection from './components/EmergencySection';
import Footer from './components/Footer';

const ACServiceLandingPage = () => {
  const [initialService, setInitialService] = useState('');

  const handleScrollToContact = (service = '') => {
    setInitialService(service);
    setTimeout(() => {
      const contactElement = document.getElementById('kontak');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection onScrollToContact={() => handleScrollToContact('konsultasi')} />
        <AboutUsSection />
        <ProblemSection />
        <ServicesSection onScrollToContact={handleScrollToContact} />
        <BenefitsSection />
        <BeforeAfterGallery />
        <TestimonialsSection />
        
        <FAQSection />
        <EmergencySection 
          onScheduleMaintenance={() => handleScrollToContact('maintenance')}
          onConsultation={() => handleScrollToContact('konsultasi')}
        />
        <ContactSection initialService={initialService} setInitialService={setInitialService} />
      </main>
      <Footer />
    </div>
  );
};

export default ACServiceLandingPage;